// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2856":"c50b14c9","7504":"c50b14c9","7588":"e54a582b","9264":"507a7b84"}[chunkId] + ".css";
};